import {Grid, Typography} from '@mui/material';
import {Link} from '@jobseeker/lotus/elements';
import React from 'react';
import {BLOGLIST} from '@constants';
import {cleanUrl} from '@jobseeker/lotus/utils';

const Blogs = () => {
  return (
    <>
      <Typography component="h2" mt={2} mb={1}>
        Blog
      </Typography>
      <Grid container spacing={2}>
        {BLOGLIST.map((blog: string) => (
          <Grid item key={blog} xs={4}>
            <Link href={`blog/category/${cleanUrl(blog)}`} target="_blank">
              {blog}
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Blogs;
